import Moment from "moment";
import Util from '@/helper/Utility.js';

//#region history config
export function CustomHistoryConfigModel () {
    this.config = 'purchase_notuse'; //purchase_used, purchase_notuse
    this.byConfig = true;
    this.top = 25;
    this.skip = 0;
    this.startdate = null;
    this.enddate = null;

    this.getParams = function () {
        var params = {
            config: this.config,
            byConfig: this.byConfig,
            top: this.top,
            skip: this.skip,
            startdate: this.startdate,
            enddate: this.enddate,
        };

        return Util.cleanObjectNullKey(params);
    };
}

export function CustomHistoryConfigBuilder() {
    this.historyConfig = new CustomHistoryConfigModel();

    this.create = function () {
        return this.historyConfig;
    };

    this.setDate = function (year, month) {
        if (year && month) {
            if(month == 'all' && year){
                this.historyConfig.startdate = `${year}-01-01T00:00:00`;
                this.historyConfig.enddate = `${year}-12-31T23:59:59`;
            }else{
                month = month.padStart('0', 2);
                var lastDay = Moment(`${year}-${month}-01`).endOf('month').get('date');
                this.historyConfig.startdate = `${year}-${month}-01T00:00:00`;
                this.historyConfig.enddate = `${year}-${month}-${lastDay}T23:59:59`;
            }
        } else {
            this.historyConfig.startdate = null;
            this.historyConfig.enddate = null;
        }
        return this;
    };

    this.setTop = function (top) {
        this.historyConfig.top = top;
        return this;
    };

    this.addSkip = function () {
        this.historyConfig.skip += this.historyConfig.top;
        return this;
    };

    this.setSkip = function (skip) {
        this.historyConfig.skip = skip;
        return this;
    };

    this.setConfig = function (config) {
        this.historyConfig.config = config;
        return this;
    };

    this.resetConfig = function () {
        this.historyConfig.skip = 0;
        // this.historyConfig.startdate = null;
        // this.historyConfig.enddate = null;
        return this;
    };
}
//#endregion history
